export default "__VITE_ASSET__D2UeU$DE__"